export default __webpack_public_path__ + "static/media/NotoSans-ExtraBold.7d1460f8.eot";